const config = {
  APP_URL: process.env.REACT_APP_URL,
  API_URL: process.env.REACT_APP_API_URL,
  REQUEST_TIMEOUT_MILLISECONDS: process.env.REACT_APP_REQUEST_TIMEOUT_MILLISECONDS,
  DEFAULT_LOCAL: process.env.REACT_APP_DEFAULT_LOCAL,
  ITEMS_PER_PAGE: process.env.REACT_APP_ITEMS_PER_PAGE,
  FETCH_COUNT: process.env.REACT_APP_FETCH_COUNT,
};

export default config;